import React, { useEffect } from 'react';
import { useTweetSyncStore } from '../stores/tweetSync/tweetSyncStore';

interface TwitterCreditDisplayProps {
  remainingCredits?: number; // 하드코딩된 값 (fallback용)
  totalCredits?: number;
}

const TwitterCreditDisplay: React.FC<TwitterCreditDisplayProps> = ({ 
  remainingCredits: fallbackCredits, 
}) => {
  const { 
    accountInfo, 
    isAccountInfoLoading, 
    accountInfoError, 
    fetchAccountInfo 
  } = useTweetSyncStore();

  // 컴포넌트 마운트 시 계정 정보 조회 및 1분마다 자동 갱신
  useEffect(() => {
    // 즉시 조회
    fetchAccountInfo();
    
    // 1분(60000ms)마다 자동 갱신
    const interval = setInterval(() => {
      fetchAccountInfo();
    }, 60000);
    
    // 컴포넌트 언마운트 시 인터벌 정리
    return () => {
      clearInterval(interval);
    };
  }, [fetchAccountInfo]);

  // 실제 크레딧 데이터 또는 fallback 값 사용
  const actualCredits = accountInfo?.recharge_credits ?? fallbackCredits ?? 0;
  const formatNumber = (num: number) => {
    return num.toLocaleString();
  };

  const getCreditColor = (remaining: number) => {
    const percentage = (remaining / 1_000_000) * 100;
    if (percentage > 100) return 'text-green-400';
    if (percentage > 50) return 'text-yellow-400';
    if (percentage > 20) return 'text-orange-400';
    return 'text-red-400';
  };


  return (
    <div className="flex items-center space-x-3 px-4 py-1 rounded-lg border border-gray-600">
      {/* Twitter 아이콘 */}
      <div className="flex items-center space-x-2">
        <svg className="w-5 h-5 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
        <span className="text-sm font-medium text-gray-300">API Credits</span>
      </div>

      {/* 크레딧 정보 */}
      <div className="flex items-center space-x-2">
        {isAccountInfoLoading ? (
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 border-2 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
            <span className="text-sm text-gray-400">Loading...</span>
          </div>
        ) : accountInfoError ? (
          <div className="flex items-center space-x-2">
            <span className="text-sm text-red-400">오류</span>
            <button 
              onClick={fetchAccountInfo}
              className="text-xs text-blue-400 hover:text-blue-300 underline"
            >
              재시도
            </button>
          </div>
        ) : (
          <span className={`text-lg font-bold ${getCreditColor(actualCredits)}`}>
            {formatNumber(actualCredits)}  <span className="text-xs text-gray-400 font-normal">(${(actualCredits * 0.00001).toFixed(2)})</span>

          </span>
        )}
      </div>
    </div>
  );
};

export default TwitterCreditDisplay;
